package devxertech.com.pages.services.devOperation.devMobDevelopment

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextTransform
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textTransform
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.pages.commons.WebDesignBoxes
import devxertech.com.pages.commons.toolUseHeading
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Constants
import devxertech.com.utils.Res
import kotlinx.browser.window
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun DevMobileSection(breakpoint: Breakpoint) {
    val sitePalette = ColorMode.current.toSitePalette()

    val largeTextModifier = Modifier
        .margin(bottom = if (breakpoint < Breakpoint.MD) 5.px else 20.px)
        .fontSize(if (breakpoint > Breakpoint.MD) 35.px else 20.px)
        .fontFamily(Constants.FONT_FAMILY)
        .fontWeight(FontWeight.Bold)
        .textTransform(TextTransform.Uppercase)


    Column(modifier = Modifier.fillMaxWidth().padding(top = if (breakpoint < Breakpoint.MD) 10.px else if (window.screen.width > 1600) 10.px else 60.px,
        bottom = if (breakpoint < Breakpoint.MD) 10.px else 60.px),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        toolUseHeading(breakpoint)
        Column(horizontalAlignment = Alignment.CenterHorizontally) {
            Row(modifier = Modifier.flexWrap(FlexWrap.Wrap),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.Center
            ) {
                SpanText(text = "Our Favorites in ",
                    modifier = largeTextModifier.color(sitePalette.commonSecondaryButtonColor.rgb)
                )
                SpanText(text = "Mobile Development",
                    modifier = largeTextModifier.color(sitePalette.primary.rgb)
                )
            }
        }
        Column(modifier = Modifier,
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Row(modifier = Modifier.fillMaxWidth
                (when {breakpoint > Breakpoint.LG -> 1200.px
                breakpoint == Breakpoint.LG -> 100.percent
                breakpoint >= Breakpoint.MD -> 85.percent
                else -> 100.percent })
                .padding(top = 30.px, bottom = if (breakpoint == Breakpoint.MD) 20.px else 30.px)
                .gap(when {breakpoint < Breakpoint.MD -> 5.px
                    breakpoint == Breakpoint.MD -> 25.px
                    breakpoint == Breakpoint.LG -> 10.px
                    else -> 33.px })
                .flexWrap(FlexWrap.Wrap),
                horizontalArrangement = Arrangement.SpaceAround,
                verticalAlignment = Alignment.CenterVertically
            ) {
                WebDesignBoxes(Res.Image.devOps_1, "Docker", 75.px, 48.px,0.px, 0.px, 13.px, 0.px)
                WebDesignBoxes(Res.Image.devOps_2, "Puppet", 29.px, 86.px, 10.px, 0.px, (-10).px, 20.px)
                WebDesignBoxes(Res.Image.devOps_3, "Ansible", 59.px, 55.px, 0.px, 10.px, 0.px, 0.px)
                WebDesignBoxes(Res.Image.devOps_4, "Chef", 51.px, 52.px, 0.px, 10.px, 0.px, 0.px)
                WebDesignBoxes(Res.Image.devOps_5, "Git", 54.px, 54.px,0.px, 10.px, 0.px, 0.px)
                WebDesignBoxes(Res.Image.devOps_6, "Gradle", 58.px, 48.px,0.px, 5.px, 5.px, 0.px)
                WebDesignBoxes(Res.Image.devOps_7, "Selenium", 50.px, 60.px,0.px, 0.px, 5.px, 0.px)
                WebDesignBoxes(Res.Image.devOps_8, "Bamboo", 53.px, 65.px, 0.px, 0.px, 5.px, 5.px)
                WebDesignBoxes(Res.Image.devOps_9, "Jenkins", 47.px, 78.px,0.px, 0.px, 0.px, 10.px)
                WebDesignBoxes(Res.Image.devOps_10, "Maven", 52.px, 72.px, 0.px, 0.px, 5.px, 5.px)
            }
        }
    }
}



